import { Col, Layout, Row } from 'antd'
import { Outlet } from 'react-router-dom'
import MainHeader from '../components/MainHeader'

import { Link } from 'react-router-dom'
import { LayoutFooter } from '../components/LayoutFooter'
import { Permission } from '../../utils/permissions'
import { useHasAccess } from '../../components/HasAccess'

const { Content } = Layout

export const VenuesLayout: React.FC = () => {
  const { hasAccess } = useHasAccess()

  const subItems = [
    {
      key: 'list',
      label: <Link to={'list'}>Venues</Link>,
      hasAccess: hasAccess(Permission.listVenue),
    },
    {
      key: 'tags',
      label: <Link to={'tags'}>Tags</Link>,
      hasAccess: hasAccess(Permission.listTag),
    },
    {
      key: 'clusters',
      label: <Link to={'clusters'}>Clusters</Link>,
      hasAccess: hasAccess(Permission.listCluster),
    },
  ]

  return (
    <Layout>
      <MainHeader subItems={subItems.filter((item) => item.hasAccess)} />
      <Layout style={{ minHeight: '100vh', marginTop: 128 }}>
        <Content>
          <Row className="container-row">
            <Col xs={24} className="px-4">
              <Outlet />
            </Col>
          </Row>
        </Content>
        <LayoutFooter />
      </Layout>
    </Layout>
  )
}
